module.exports = __webpack_public_path__ + "static/media/voz-icon.725b024a.svg";